import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const typesApi = {

    createRecruitmentType: ({name, domestic}) => {
      return axiosInstance.post(
        `${adminBaseUrl}/recruitmentType`,
        {
            "name": name,
            "domestic": domestic
        }
      )
    },

    updateRecruitmentType: ({id, name, domestic}) => {
        return axiosInstance.put(
            `${adminBaseUrl}/recruitmentType/${id}`,
            {
                "name": name,
                "domestic": domestic
            }
        )
    },

    deleteRecruitmentType: (id) => {
        return axiosInstance.delete(`${adminBaseUrl}/recruitmentType/${id}`)
    },

    createCompanyType: ({name, domestic}) => {
        return axiosInstance.post(
          `${adminBaseUrl}/companyType`,
          {
              "name": name,
              "domestic": domestic
          }
        )
      },
  
      updateCompanyType: ({id, name, domestic}) => {
          return axiosInstance.put(
              `${adminBaseUrl}/companyType/${id}`,
              {
                  "name": name,
                  "domestic": domestic
              }
          )
      },
  
      deleteCompanyType: (id) => {
          return axiosInstance.delete(`${adminBaseUrl}/companyType/${id}`)
      },

      createIndustryType: ({name, domestic}) => {
        return axiosInstance.post(
          `${adminBaseUrl}/industryType`,
          {
              "name": name,
              "domestic": domestic
          }
        )
      },
  
      updateIndustryType: ({id, name, domestic}) => {
          return axiosInstance.put(
              `${adminBaseUrl}/industryType/${id}`,
              {
                  "name": name,
                  "domestic": domestic
              }
          )
      },
  
      deleteIndustryType: (id) => {
          return axiosInstance.delete(`${adminBaseUrl}/industryType/${id}`)
      },
    // 其他 API 方法可以在这里添加
  } 